import { Node } from '@lumapps/wrex/slate';

import { isHeading } from './isHeading';
import { isParagraph } from './isParagraph';

/**
 * Check if the given node is a node which we can text apply alignment
 */
export const isAuthorizedAlignmentNode = (node: Node) => {
    return isParagraph(node) || isHeading(node);
};
